import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent7: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Define high-level product specifications</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Define high-level product specifications
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step you will create a visual representation of your product, to ensure that it is focused on your target customer and also that everyone on your team agrees on what the product/offering is. The description must be focused on the benefits of your product created by the features and not just the features.

The customer is really interested in benefits, the features are just a means to this end. Visually laying out your product will allow your team and your potential customers to converge around an understanding of what the product is and removes ambiguities that often arise when this step is skipped. It also begins to clarify how it will benefit your target customers. Staying at a high level, without too many details or a physical prototype, allows for rapid revision without investing too much time and resources too early in the process of creating your new venture. Remember, you are now in inquiry mode, not advocacy mode.

Building a visual representation of the product may well turn out to be harder than you think, but will get everyone on the same page, which will prove extremely valuable going forward. If it is not, then be happy but still document what your product is so you can begin to iterate with your targeted customers.

This brochure with features, function, and benefits to the customer further clarifies your product offering and will be a great complement to the pictures you create.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Create the high-level product specifications
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  At this stage, the product does not have to be built and almost surely should not, because this will incur unnecessary costs and create something that your team is too attached to. Keep it high level and don’t get distracted at this point.

It will not only cost you more if you build at this stage but it will immediately get you distracted, and the team will focus on the wrong things, like the particulars of the technology.

Create preliminary sketches of the product (diagrams for hardware, or wireframes for software products).
Get agreement from your team on the sketches.
Refine the sketches with your team, to the stage where you can show them to a few selected potential customers.
Share or discuss with potential customers to get further feedback.
Further refine the sketches based on feedback, to the stage where you can include them in a presentation or brochure about your product.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_3">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_3"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_3"
                  >
                    Create a product brochure (printed and/or digital)
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_3"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_3"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Building a brochure helps you see your product from the customer’s point of view and provides a concrete “straw man” to test with your customer. It forces you to see your new venture from your customer’s vantage point, and in their words. It also allows you to validate your ideas and learn if you are on the right track. Often, when entrepreneurs begin to write down features, they become too inwardly focused. Creating a brochure helps to avoid that pitfall.

Describe various features of your product.
Explain how these features translate into function.
Explain why your target customer needs your product, and how it benefits or solves the problem.
Design a printable or digital (PDF or website) brochure for your product.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent7 };
